export default {
  overlay: false,
  snackbar: {
    show: false,
    color: '',
    message: '',
    multiline: false
  }
};
